import Address from './Address';
import Attribute from './Attribute';
import CalendarEvent from './CalendarEvent';
import Carousel from './Carousel';
import Cart from './Cart';
import Catalog from './Catalog';
import Category from './Category';
import CategoryList from './CategoryList';
import EventReservation from './EventReservation';
import InventoryBuffer from './InventoryBuffer';
import Offer from './Offer';
import Order from './Order';
import PaymentType from './PaymentType';
import Preorder from './Preorder';
import Product from './Product';
import ProductList from './ProductList';
import Role from './Role';
import ShipmentManifest from './ShipmentManifest';
import ShopSale from './ShopSale';
import Sidebar from './Sidebar';
import StockAccount from './StockAccount';
import Supplier from './Supplier';
import SupplierOrder from './SupplierOrder';
import Unit from './Unit';
import User from './User';
import Voucher from './Voucher';

const Structures = {
    Address,
    Attribute,
    CalendarEvent,
    Catalog,
    Category,
    Order,
    Product,
    Role,
    ShipmentManifest,
    User,
    Offer,
    PaymentType,
    ProductList,
    Carousel,
    Supplier,
    SupplierOrder,
    CategoryList,
    ShopSale,
    Sidebar,
    StockAccount,
    Unit,
    Cart,
    Voucher,
    Preorder,
    InventoryBuffer,
    EventReservation
}

export default Structures;
